import axios from "../axios";

export const GET_YEAR_SUCCESS = 'METADATA_GET_YEAR_SUCCESS';
export const GET_YEAR_ERROR = 'METADATA_GET_YEAR_ERROR';

export const GET_TEAM_SUCCESS = 'METADATA_GET_TEAM_SUCCESS';
export const GET_TEAM_ERROR = 'METADATA_GET_TEAM_ERROR';

const getMasterYears = () => {
    return async (dispatch) => {
        try {
            const {data} = await axios.get('api/masters/years');
            dispatch({
                type: GET_YEAR_SUCCESS,
                data,
            });
            return data;
        }catch (error) {
            dispatch({
                type: GET_YEAR_ERROR,
                error,
            });
        }
    };
};

const getMasterTeams = () => {
    return async (dispatch) => {
        try {
            const {data} = await axios.get('api/masters/teams');
            dispatch({
                type: GET_TEAM_SUCCESS,
                data: [...data.central_league, ...data.pacific_league],
                leagues: {
                    central: data.central_league,
                    pacific: data.pacific_league,
                },
            });
            return [...data.central_league, ...data.pacific_league];
        } catch (error) {
            dispatch({
                type: GET_TEAM_ERROR,
                error
            });
        }
    };
};

export {
    getMasterYears,
    getMasterTeams,
};
